<template>
    <div>        
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/activity/pointPresentRecordsCancel')" type="primary" icon="el-icon-delete" @click="cancelCode()" size="small" :disabled="haveEditAudit" plain>批量作废</el-button>
            <el-button v-if="$utils.have('/activity/pointPresentRecordsExport')" type="primary" icon="el-icon-download" @click="download" size="small" plain :loading="downLoading">导出信息</el-button>
        </div>
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe @selection-change="handleSelectionChange">
                <el-table-column type="selection"></el-table-column>
                <el-table-column prop="statusView" label="状态" min-width="140">                    
					<template slot-scope="scope">						
						<p>有效状态： {{scope.row.statusView}}</p>						
					</template>
                </el-table-column>
				<el-table-column prop="ticketId" label="票品id" min-width="220"></el-table-column>
				<el-table-column prop="ticketName" label="赠票名称" min-width="120" show-overflow-tooltip></el-table-column>	
				<el-table-column label="是否实名" prop="realNameView"></el-table-column>
				<el-table-column label="积分商品名称" prop="pointGoodsName" min-width="150" show-overflow-tooltip></el-table-column>
				<el-table-column prop="userId" label="兑换用户" min-width="140"> </el-table-column>
                <el-table-column prop="telephone" label="兑换手机号" min-width="120"></el-table-column>
                <el-table-column  label="观演人信息"  min-width="150">
                	<template slot-scope="scope">
                		<p v-if="scope.row.documentName">{{scope.row.documentName}}</p>
                		<p v-if="scope.row.documentNumber">{{scope.row.documentNumber}}</p>	
                		<p v-if="!scope.row.documentNumber && !scope.row.documentNumber" class="color-danger">暂无</p>	
                	</template>
                </el-table-column>
				<el-table-column  label="座位号信息" min-width="220">
					<template slot-scope="scope">
						<template v-if="scope.row.seatName">
							{{scope.row.seatName}}
						</template>
						<template v-else>
							<p class="color-danger">暂无</p>
						</template>
					</template>
				</el-table-column>				
                <el-table-column label="兑换时间" min-width="220" prop="exchangeTime"></el-table-column>                
                <el-table-column v-if="!haveEditAudit" fixed="right" label="操作" width="160">
                    <template slot-scope="{row} = scope">
                        <el-button v-if="$utils.have('/activity/pointPresentRecordsCancel') && row.statusView !='作废' " type="text" size="small" icon="el-icon-document-delete"
                            @click="cancelCode(row.id)" >作废删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import {downloadFileTmp} from '@/assets/js/commonApi.js';
export default {
    props: {
        activityId: {
            type: [Number, String],
            default: () => null
        },
        haveEditAudit: {
            type: Boolean,
            default: false
        },
        
    },
    data() {
        return {
            data: null,
            dataList: null,
            params: {
				pageNo: 1,
                pageSize: this.$pageSizes[0],
            },
            listLoading: true,
            ticketIds: [],
            downLoading:false,            
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/activity/pointPresentRecords",
                method: "POST",
                data: {
                    ...this.params,
                    activityId: this.activityId
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.data = null;
                        this.dataList = [];
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //全选、反选
        handleSelectionChange(val) {
            this.ticketIds = val.map( v => v.id );
        },
        //作废
        cancelCode(id){
            let  _ticketIds = [], _msg = "";
            if( id ){
                _ticketIds = [id];
                _msg = "确定要作废删除当前兑换的赠票吗?"
            }else{
                _ticketIds = [...this.ticketIds]
                if( _ticketIds.length < 1 ){
                    return this.$message.error("请选择需要作废删除的赠票");
                }
                _msg = "确定要批量作废删除当前兑换的赠票吗?";
            }
            this.$confirm(_msg, '作废删除', {
                // type: 'warning',
                center: true,
                closeOnClickModal: false,
            }).then(() => {
                this.listLoading = true;
                this.$request({
                    url: '/activity/pointPresentRecordsCancel',
                    method: 'POST',
                    params: {ticketIds: _ticketIds.toString()}
                }).then(res => {
                    const { state, msg } = res.data;
                    if( state == 1 ){
                        let timer = setTimeout(() => {
                            this.getDataList();
                            clearTimeout(timer);
                        },500)
                        
                    }else{
                        this.$message.error(msg || '请求失败');
                        this.listLoading = false;
                    }
                }).catch(() => {
                    this.$message.error('请求错误');
                    this.listLoading = false;
                }).finally(() => {
                    // this.listLoading = false;
                });
            })
        },
        async download(){
            let filePath, fileName;
            this.downLoading = true;
            const res = await this.$request({
                url:'/activity/pointPresentRecordsExport',
                method: 'post',
                data: {
                    ...this.params,
                    activityId: this.activityId
                },
            })
                .catch(err => {
                    this.$message({message: err.message, type: 'error'});
                })
            const{state,msg,result} = res.data;
            if(state == 1 && result){
                filePath = result.url;
                fileName = result.fileName;
            }else{
                this.downLoading = false;
                return this.$message.error(msg || '下载失败');
            }   

            await downloadFileTmp(filePath, fileName+'.'+this.$utils.getFileType(filePath));

            this.downLoading = false;
        },
    }
}
</script>
<style lang="scss" scoped>

</style>